import { render, staticRenderFns } from "./specialDialog.vue?vue&type=template&id=1d032d06&scoped=true&"
import script from "./specialDialog.vue?vue&type=script&lang=js&"
export * from "./specialDialog.vue?vue&type=script&lang=js&"
import style0 from "./specialDialog.vue?vue&type=style&index=0&id=1d032d06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d032d06",
  null
  
)

export default component.exports